<template>
  <v-text-field outlined :v-on="$listeners" :ref="'inputField' + inputFieldKey" v-model="valueComputed" :key="inputFieldKey" class="pr-1">
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
  </v-text-field>
</template>

<script>
import { computed, ref, onUpdated} from '@vue/composition-api'

export default {

  name: 'NumberTextField',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  setup(props, context){

    const inputFieldKey = ref(0);
    let changed = false

    const inputFilter = (value) => /^\d*$/.test(value);
    const valueComputed = computed({
      get: () => props.value,
      set: (value) => {
        if (inputFilter(value)) context.emit('input', value)
        else if(inputFilter(props.value)) {
          valueComputed.value = props.value
          inputFieldKey.value += 1
          changed = true
        }else {
          valueComputed.value = ''
          inputFieldKey.value += 1
          changed = true
        }
      }
    })

    onUpdated(() => {
      if(changed) {
        context.refs['inputField' + inputFieldKey.value].$el.querySelector('input:not([type=hidden]),textarea:not([type=hidden])').focus()
        changed = false
      }
    });

    return {valueComputed, inputFieldKey}
  }
}
</script>

<style scoped lang="scss">
.v-input {
  position: relative;

  &.pr-1 {
    &::after {
      position: absolute;
      right: 0;
      bottom: 0;
      background-color: map-get($grey, 'lighten-4');
      content: '';
      width: 8px;
      height: 1px;
    }
  }
}
</style>

<!-- The following style have to be declared as global styles, otherwise they have no effect. -->
<style lang="scss">
.v-input {
  .v-input__prepend-outer {
    position: relative;

    &::after {
      position: absolute;
      left: 0;
      right: 8px;
      bottom: 0;
      background-color: map-get($grey, 'lighten-4');
      content: '';
      height: 1px;
    }
  }

  .v-input__control {
    position: relative;
    z-index: 1;
  }
}
</style>
